<template>
    <div @click="emitDirections" :class="{'uk-card':true, 'uk-card-hover':true, 'uk-card-primary': data.odd, 'comment': true, 'uk-card-secondary': !data.odd}">
        <p>{{ data.message }}</p>
        <div uk-grid>
        <div class="uk-text-small uk-width-auto@m">For: {{data.source}} </div>
        <div class="uk-text-small uk-text-right uk-width-auto@m">On: {{data.time}} </div>
        <div class="uk-text-small uk-text-right uk-width-auto@m">ID: {{data.id}} </div>
        </div>

    </div>
</template>

<script>
    export default {
        name: "Comment",
        props: ['data'],
        methods: {
            emitDirections: function(){
                this.$emit('singleSurvey', {
                    sc_dt: this.data.time,
                    sc_id: this.data.id,
                    active: true
                })
            }
        }
    }
</script>

<style scoped>
    .comment{
        margin: 10px;
        padding: 5px;
        cursor: pointer;
    }
    .for-line{
        margin:2px !important;
    }
</style>
